export default "__VITE_ASSET__ca284a7c__"